import { Component, Input, OnInit } from "@angular/core";
import { DeleteConfirmationModalComponent } from "src/app/dashboard/main/accountant/modals/delete-confirmation-modal.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { FilesManagerService } from "src/app/dashboard/files-manager/files-manager.service";

import { CommonModule } from "@angular/common";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { HotToastService } from "@ngneat/hot-toast";

@Component({
    selector: "app-initial-folders",
    templateUrl: "./initial-folders.component.html",
    styleUrls: [
        "./initial-folders.component.scss",
        "../../../../main/accountant/tracked-items-dashboard.component.css",
        "../../../../files-manager/files-manager.component.scss",
    ],
    imports: [CommonModule, BsDropdownModule]
})
export class InitialFoldersComponent implements OnInit {
  sharedStaff: string = "client";
  dfTabTitle: string = "Client Shared Default Folders";
  clientSharedCount: any = 0;
  currentFolder: any = [];
  btnFolderBackVisible: boolean = false;
  internalCount: any = 0;
  clientSharedCountDisplay: any = "0 folders";
  internalCountDisplay: any = "0 folders";
  renameFolderVisible: boolean = false;
  uuidToDelete: any;
  createFolderVisible: boolean = false;
  is_loading: boolean;
  user: any;
  data: any;
  company: any;
  disableApplyImmediatelyInput = false;
  addFolderAutomatically = false;

  constructor(
    private localStorage: LocalStorageService,
    private filesManagerService: FilesManagerService,
    private modalService: BsModalService,
    private toastr: HotToastService,
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    this.company = this.localStorage.get("company");

    this.getFilteredDefaultFolders();
    this.getClientSharedDefaultCount();
    this.getInternalDefaultCount();
  }

  clientSharedStaff() {
    this.sharedStaff = "client";
    console.log("clientSharedStaff switched to: ", this.sharedStaff);
    this.dfTabTitle = "Client Shared Default Folders";
    console.log("this.dfTabTitle changed to: ", this.dfTabTitle);
    this.getFilteredDefaultFolders();
  }

  getFilteredDefaultFolders() {
    console.log("Inside Get Filtered Default Folders");
    if (this.company.id == null) {
      return;
    }

    if (this.sharedStaff == "client") {
      this.filesManagerService
        .getDefaultAll(this.company.id)
        .then((res: any) => {
          const data = res;
          console.log(data);
          this.clientSharedCount = 0;
          for (const folder of data.folders) {
            this.clientSharedCount++;
          }
          // this.defaultsToShow = data;
          this.currentFolder = data;
          // console.log("DefaultsToShow: ", this.defaultsToShow);
          console.log("currentFolder: ", this.currentFolder);
          this.btnFolderBackVisible = false;
          this.dfTabTitle = "Client Shared Default Folders";
        });
    } else if (this.sharedStaff == "staff") {
      this.filesManagerService
        .getStaffDefaultOnly(this.company.id)
        .then((res: any) => {
          const data = res;
          console.log(data);
          // this.defaultsToShow = data;
          this.currentFolder = data;
          this.internalCount = 0;
          for (const folder of data.folders) {
            this.internalCount++;
          }
          // console.log("DefaultsToShow: ", this.defaultsToShow);
          console.log("currentFolder: ", this.currentFolder);
          this.btnFolderBackVisible = false;
          this.dfTabTitle = "Internal Default Folders";
        });
    } else {
      console.log(
        "sharedStaff var was not set to either 'client' or 'staff'. Could not fetch default folders.",
      );
    }
  }

  staffSharedStaff() {
    this.sharedStaff = "staff";
    console.log("clientSharedStaff switched to: ", this.sharedStaff);
    this.dfTabTitle = "Internal Default Folders";
    console.log("this.dfTabTitle changed to: ", this.dfTabTitle);
    this.getFilteredDefaultFolders();
  }

  folderBackButton() {
    // navigates to previous folder (back arrow in middle column)
    console.log("Folder Back Button");
    if (this.currentFolder.parent_id != null) {
      this.getParentDefaultFolder(this.currentFolder.uuid);
    } else {
      this.getFilteredDefaultFolders();
    }
  }

  getParentDefaultFolder(folder_uuid) {
    // retrieve a default folder's parent folder by a given uuid
    this.filesManagerService
      .getParentDefaultFolder(this.company.id, folder_uuid)
      .then((res: any) => {
        const data = res;
        console.log(data);
        this.currentFolder = data;
        console.log("parent, now currentFolder=", this.currentFolder);
        this.dfTabTitle = this.currentFolder.title;
        this.btnFolderBackVisible = true;
        this.reload();
      });
    // this.defaultsToShow = this.currentFolder
  }

  reload() {
    // reloads open folder
    this.getClientSharedDefaultCount();
    this.getInternalDefaultCount();
    if (this.currentFolder.uuid) {
      this.getDefaultFolder(this.currentFolder.uuid);
    } else {
      try {
        this.getFilteredDefaultFolders();
        console.log("Got filtered default folders");
      } finally {
        console.log("couldnt decide which folder to reload");
        console.log("selected folder was", this.currentFolder);
      }
    }
  }

  getClientSharedDefaultCount() {
    this.filesManagerService.getDefaultAll(this.company.id).then((res: any) => {
      const data = res;
      this.clientSharedCount = 0;
      for (const folder of data.folders) {
        this.clientSharedCount++;
      }
      if (this.clientSharedCount == 1) {
        this.clientSharedCountDisplay = "1 folder";
      } else {
        this.clientSharedCountDisplay = this.clientSharedCount + " folders";
      }
    });
  }

  createFolderActivate() {
    this.createFolderVisible = true;
  }

  renameDefaultFolder(uuid: string, name: string) {
    console.log(
      "renaming default folder",
      this.currentFolder.title,
      "to",
      name,
    );
    console.log("uuid", uuid);
    this.is_loading = true;
    this.filesManagerService
      .renameDefaultFolder(this.company.id, uuid, name)
      .then(
        (result) => {
          this.is_loading = false;
          console.log("successfully renamed");
          this.reload();
          this.toastr.success("Default folder renamed successfully.");
          this.renameFolderVisible = false;
        },
        (error) => {
          this.is_loading = false;
          console.log("failed to rename");
          this.toastr.error(
            "Something went wrong when renaming the default folder.",
          );
          this.renameFolderVisible = false;
        },
      );
  }

  createDefaultFolder(name: string) {
    console.log("INSIDE createDefaultFolder()");
    if (typeof name === "string" && name.length === 0 || name === null) {
      this.toastr.error("Please fill out the folder name before creating it.");
      return;
    }
    const parentUUID = this.currentFolder.uuid; // Figure out how to get hierarchy on default folders templates page
    const isStaffOnly = this.sharedStaff == "staff";
    const company_id = this.company.id;
    console.log("Puuid,staff", parentUUID, isStaffOnly);
    try {
      this.filesManagerService
        .createDefaultFolder(company_id, parentUUID, name, isStaffOnly, this.addFolderAutomatically)
        .then(
          (result) => {
            this.reload();
            console.log("successfully created");
            this.toastr.success("Folder created successfully.");
          },
          (error) => {
            console.log("failed to create");
            this.toastr.error("Something went wrong when creating the folder.");
          },
        );
      console.log("create ", name);
    } catch (error) {
      console.error(error);
    }
    this.createFolderVisible = false;
  }

  getInternalDefaultCount() {
    this.filesManagerService
      .getStaffDefaultOnly(this.company.id)
      .then((res: any) => {
        const data = res;
        this.internalCount = 0;
        for (const folder of data.folders) {
          this.internalCount++;
        }
        if (this.internalCount == 1) {
          this.internalCountDisplay = "1 folder";
        } else {
          this.internalCountDisplay = this.internalCount + " folders";
        }
      });
  }

  getDefaultFolder(folder_uuid) {
    // retrieve a default folder by a given uuid
    this.filesManagerService
      .getDefaultFolder(this.company.id, folder_uuid)
      .then((res: any) => {
        const data = res;
        console.log(data);
        this.currentFolder = data;
        console.log("CURRENTFOLDER.FOLDERS", this.currentFolder.folders);
        this.dfTabTitle = this.currentFolder.title;
        this.btnFolderBackVisible = true;
      });
    // this.defaultsToShow = this.currentFolder
  }

  deleteDefaultFolder(uuid: string) {
    console.log("deleting DEFAULT folder", uuid);
    this.filesManagerService.deleteDefaultFolder(this.company.id, uuid).then(
      (success) => {
        console.log("successfully deleted");
        this.reload();
        this.folderBackButton();
        this.toastr.success(`Folder deleted successfully.`);
      },
      (error) => {
        console.log("failed to delete");
        this.toastr.error("Something went wrong when deleting the folder.");
      },
    );
  }

  public openDeleteConfirmationModal() {
    const initialState = {
      displayName: this.currentFolder.title,
    };

    const deleteModal = this.modalService.show(
      DeleteConfirmationModalComponent,
      { initialState },
    );
    deleteModal.content.onClose.subscribe((confirmed) => {
      if (confirmed) {
        if (this.currentFolder.parent_id) {
          try {
            this.uuidToDelete = this.currentFolder.uuid;
            this.folderBackButton();
            this.deleteDefaultFolder(this.uuidToDelete);
          } catch (err) {
            console.log("Inside catch");
            console.log(err);
          }
        } else {
          this.deleteDefaultFolder(this.currentFolder.uuid);
          this.getFilteredDefaultFolders();
        }
      }
    });
  }
}
